<ng-template [ngIf]="state == 'loading'">
  <mat-progress-spinner style="margin: auto;" mode="indeterminate"></mat-progress-spinner>
</ng-template>
<div *ngIf="state != 'loading'" class="center">
  <div class="row">
    <div class="offset-sm-5 col-sm-3">
      <h1 class="ml-5">Merci</h1>
    </div>
  </div>
  <div class="row">
    <div class="offset-sm-4 col-sm-3">
      <h2 class="ml-5">
        Votre consentement a été enregistré avec succès
      </h2>
    </div>
  </div>
</div>
